module.exports = __webpack_public_path__ + "assets/img/filePic.eeab0462.png";